(function () {
	'use strict';

	angular
    .module('app.setup')
    .controller('dashboardTemplates', dashboardTemplates);

	dashboardTemplates.$inject = ['$rootScope', '$scope', '$timeout'];

	function dashboardTemplates($rootScope, $scope, $timeout) {
		var vm = this;

		$scope.siteId = globalConfig.factory.id;
		$scope.customerId = globalConfig.customer.id;
		// Set navigation properties
	}
})();